import React, { Component } from 'react';
import { connect } from 'react-redux';
import Scrollbars from 'react-custom-scrollbars';
import OutsideClickHandler from 'react-outside-click-handler';
import { toggleSideMenu } from './../../actions/globalActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import './css/index.scss';

const AppAuth = {
  isAuthenticated: localStorage.getItem('token') ? true : false
}

class Sidebar extends Component {
  // constructor(props){
  //   super(props);

  // }

  render(){
    // let props = this.props;
    return (
      <OutsideClickHandler
        onOutsideClick={() => {
          if(this.props.sideMenuOpened === true)
          {
            this.props.toggleSideMenu();
          }
        }} 
      >
      <aside className={ `rightSidebar` } style={{width: this.props.sideMenuOpened === false ? '0' : '300px', visibility: this.props.sideMenuOpened === false ? 'hidden' : 'visible'}}>
          <div className="rightSidebar-content">
          <Scrollbars
            universal={true}
          >
            {AppAuth.isAuthenticated === true ? (
            <div>
              <ul className="right-menu">
                <li className="noHover"><FontAwesomeIcon className="userAvatar" icon="user" /> <span>{this.props.profile !== null ? this.props.profile.name : null}</span></li>
                <li><Link onClick={this.props.toggleSideMenu} to="/setari-cont"><FontAwesomeIcon icon="user" />Setări cont</Link></li>
                <li><Link onClick={this.props.toggleSideMenu} to="/tabulaturile-mele"><FontAwesomeIcon icon="music" />Tabulaturile Mele</Link></li>
                <li onClick={()=>{localStorage.removeItem('token'); window.location.reload();}}><Link to="/"><FontAwesomeIcon icon="sign-out-alt" />Deconectare</Link></li>
              </ul>
            </div>) : (<div>
              <ul className="right-menu">
              <li><Link className="shownOnSmall" onClick={this.props.toggleSideMenu} to="/autentificare"><FontAwesomeIcon icon="user" />Autentificare</Link></li>
              </ul>
            </div>)}
            <div className="separator"></div>
            <ul className="right-menu">
              <li><Link onClick={this.props.toggleSideMenu}  to="/adauga-tabulatura"><FontAwesomeIcon icon="plus-square" />Adaugă tabulatură</Link></li>
              {/* <li><Link onClick={this.props.toggleSideMenu}  to="/cere-tabulatura"><FontAwesomeIcon icon="comments" />Cere tabulatură</Link></li> */}
              <li><Link onClick={this.props.toggleSideMenu}  to="/contact"><FontAwesomeIcon icon="mobile-alt" />Contact</Link></li>
            </ul>
            
          </Scrollbars>
          </div>
      </aside>
      </OutsideClickHandler>
    );
  }
}

const mapStateToProps = state => {
  return {
    sideMenuOpened: state.global.get('sideMenuOpened'),
    profile: state.global.get('profile'),
  };
};

const mapDispatchProps = dispatch => {
  return {
    toggleSideMenu: () => {
      dispatch(toggleSideMenu());
    },
  }
};

export default connect(mapStateToProps, mapDispatchProps)(Sidebar);


// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js